// extracted by mini-css-extract-plugin
export default {"container":"PriceStep_container__CQ5R2","section":"PriceStep_section__v50Ee","tableDiv":"PriceStep_tableDiv__qNn0g"};